/* Global
  Announcement Slider */
$(".js__announcement-slider").not(".slick-initialized").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  vertical: true,
  cssEase: "ease-in-out",
  adaptiveHeight: false,
});

/* GLOBAL
    Scroll to particular Div with # value */
$('a[href^="#"]').on("click", function (event) {
  if (this.getAttribute("role") === "tab") return;
  var target = $(this.getAttribute("href"));
  if (target.length) {
    event.preventDefault();
    $(".tab-head").hide();
    $("html, body").stop().animate(
      {
        scrollTop: target.offset().top,
      },
      1000
    );
  }
});